export const gallery = {
  init: function () {
    if (jQuery(".gallery").length) {
      jQuery(".gallery a").simpleLightbox({
        /* options */
        animationSpeed: 200,
        fadeSpeed: 300,
        captionPosition: "bottom",
      });
    }

    // inicializace pro samostatné lightboxové prvky (např. hlavní obrázek)
    if (jQuery(".js-lightbox").length) {
      jQuery(".js-lightbox").simpleLightbox({
        animationSpeed: 200,
        fadeSpeed: 300,
        captionPosition: "bottom",
      });
    }
  },
};
